<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="!!data">
    <InputBasic
        v-model="data"
        :db="db"
        :args="args"
        :skipped="skipped"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "../../../helpers/questionLoadHelpers";

import QuestionBase from "../../../QuestionBase";
import InputBasic from "@/components/common/questionnaires/question/inputs/InputBasic";

export default {
  name: 'DivorcePersonName',
  mixins: [questionLoadHelpers],
  components: {
    InputBasic,
    QuestionBase
  },
  props: {
    value: {
      type: [String],
      required: false
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title:  'What is the name of your ex-spouse?',
        subTitle:  'We ask this as it may be prudent to specifically exclude them in your Will.',
        tip: null,
      },
      db: {
        saveLocation: 'client_client',
        saveField: 'profileRelationshipPreviousPersonName',
        formPath: 'clientData.profileRelationshipPreviousPersonName'
      },
      args: {
        skippable: false,
        required: true,
        inputClass: 'field-100',
        placeholder: 'e.g. Joe Malone'
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
